export default __webpack_public_path__ + "static/media/ViewDoc.6385ea2c.svg";